export const estimatesRouteNames = {
  listEstimates: 'estimates',
  estimatesEditor: 'estimates-editor',
  estimatesTemplateEditor: 'estimates-template-editor',
}
